export default __webpack_public_path__ + "static/media/non.5381e608.png";